
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe05 as ObiHydraulicPipe05Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-05.js';
 
 
 

 
 export const ObiHydraulicPipe05 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-05',
   elementClass: ObiHydraulicPipe05Element,
   events: {
     
   }
  });
 
 